<template>
  <div v-if="suggestions.length" class="followup-bubbles">
    <button
      v-for="(q, idx) in suggestions"
      :key="idx"
      class="followup-bubble"
      :class="{ 'followup-bubble--dark': isDarkMode }"
      @click="$emit('select', q)"
    >
      {{ q }}
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

const FOLLOWUP_PATTERNS = [
  /\*\*follow[- ]?up.*?\*\*[:\s]*/i,
  /📌.*?(?:ask|questions?)[:\s]*/i,
  /(?:you (?:might|may|could) (?:also )?(?:want to )?ask|suggested questions?|related questions?)[:\s]*/i,
  /(?:here are (?:some )?(?:follow[- ]?up|related|suggested))[:\s]*/i
];

function extractFollowUps(content) {
  if (!content) return [];
  const lines = content.split('\n');
  let capturing = false;
  const questions = [];

  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed) {
      if (capturing && questions.length) capturing = false;
      continue;
    }

    if (!capturing) {
      for (const pattern of FOLLOWUP_PATTERNS) {
        if (pattern.test(trimmed)) {
          capturing = true;
          // Check if the question is on the same line after the header
          const afterHeader = trimmed.replace(pattern, '').trim();
          if (afterHeader) {
            const cleaned = afterHeader.replace(/^[-–•*\d.)\]]+\s*/, '').replace(/\*+/g, '').trim();
            if (cleaned.length > 5) questions.push(cleaned);
          }
          break;
        }
      }
      continue;
    }

    // Capturing mode: grab numbered/bulleted lines
    const match = trimmed.match(/^[-–•*\d.)\]]+\s*(.+)/);
    if (match) {
      const cleaned = match[1].replace(/\*+/g, '').replace(/[?]$/, '?').trim();
      if (cleaned.length > 5) questions.push(cleaned);
    } else if (/^[A-Z""]/.test(trimmed) && trimmed.endsWith('?')) {
      questions.push(trimmed);
    } else {
      capturing = false;
    }
  }

  return questions.slice(0, 4);
}

export default {
  name: 'FollowUpBubbles',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('darkMode', ['isDarkMode']),
    suggestions() {
      return extractFollowUps(this.content);
    }
  }
};
</script>

<style scoped>
.followup-bubbles {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.followup-bubble {
  background: #fff;
  border: 1px solid #F28A3E;
  color: #F28A3E;
  border-radius: 16px;
  padding: 5px 14px;
  font-size: 0.82rem;
  cursor: pointer;
  transition: all 0.15s ease;
  text-align: left;
  line-height: 1.3;
}

.followup-bubble:hover {
  background: #F28A3E;
  color: #fff;
}

.followup-bubble--dark {
  background: #3a3f44;
  border-color: #F28A3E;
  color: #F28A3E;
}

.followup-bubble--dark:hover {
  background: #F28A3E;
  color: #fff;
}
</style>
